import { useEffect, useRef, useState } from "react";

interface JourneyPhoto {
  id: number;
  src: string;
  alt: string;
  delay: number;
  floatDuration: number;
  blinkDelay: number;
  rotate: number;
  scaleStart: number;
}

const journeyPhotos: JourneyPhoto[] = [
  {
    id: 1,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/da07f78a96743b34a9fc5f0d74e31bb6.jpeg",
    alt: "Certificate presentation at Sri Manakula Vinayagar Engineering College",
    delay: 0,
    floatDuration: 6,
    blinkDelay: 0,
    rotate: -2,
    scaleStart: 1,
  },
  {
    id: 2,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/adfecba99a1073079e82719080da44ea.jpeg",
    alt: "Embedded Systems workshop with Raspberry Pi",
    delay: 0.3,
    floatDuration: 7,
    blinkDelay: 1.2,
    rotate: 1.5,
    scaleStart: 1,
  },
  {
    id: 3,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/bd8f7e307a11023aa75a7f229f09d0eb.jpeg",
    alt: "Certification Program Training at Thankshila University",
    delay: 0.6,
    floatDuration: 5.5,
    blinkDelay: 0.5,
    rotate: -1,
    scaleStart: 1,
  },
  {
    id: 4,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/7e06f724a62bc53305b0ef7119078a71.jpeg",
    alt: "Data Analytics Python workshop",
    delay: 0.9,
    floatDuration: 8,
    blinkDelay: 2,
    rotate: 2,
    scaleStart: 1,
  },
  {
    id: 5,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/69660f65510ad7ad0a279fa8dbcb3b71.jpeg",
    alt: "Full lab session Data Analytics at MRK Institute",
    delay: 1.2,
    floatDuration: 6.5,
    blinkDelay: 0.8,
    rotate: -1.5,
    scaleStart: 1,
  },
  {
    id: 6,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/5bf6a51ce388ea13303f067fed91e09b.jpeg",
    alt: "AI and Data Science program at Mailam Engineering College",
    delay: 0.2,
    floatDuration: 7.5,
    blinkDelay: 1.6,
    rotate: 1,
    scaleStart: 1,
  },
  {
    id: 7,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/34cd0f7a89bcb002f4fd94170421818a.jpeg",
    alt: "Corporate training at ESAB India",
    delay: 0.5,
    floatDuration: 6,
    blinkDelay: 0.3,
    rotate: -2.5,
    scaleStart: 1,
  },
  {
    id: 8,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/a736294371415dd704268277e9e6a4b7.jpeg",
    alt: "Advanced Power BI training at ESAB",
    delay: 0.8,
    floatDuration: 5,
    blinkDelay: 2.4,
    rotate: 2.5,
    scaleStart: 1,
  },
  {
    id: 9,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/35bea1de0c26b4e4d4b0d9c77e20fa6e.jpeg",
    alt: "Robotics workshop at VKM Vidhyalaya",
    delay: 1.1,
    floatDuration: 7,
    blinkDelay: 1,
    rotate: -1.8,
    scaleStart: 1,
  },
  {
    id: 10,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/6213c6561c5632e16eabe77ae70d46b8.jpeg",
    alt: "Industry mentoring session",
    delay: 1.4,
    floatDuration: 6.8,
    blinkDelay: 1.8,
    rotate: 1.2,
    scaleStart: 1,
  },
  {
    id: 11,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/e78ff45f00622ff3a771ec9a6098a822.jpeg",
    alt: "STEMForge training session with students",
    delay: 0.25,
    floatDuration: 6.2,
    blinkDelay: 1.1,
    rotate: 1.3,
    scaleStart: 1,
  },
  {
    id: 12,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/782a6f6af94704532ca18b7572d94a19.jpeg",
    alt: "STEMForge workshop session with students",
    delay: 0.65,
    floatDuration: 7.1,
    blinkDelay: 0.7,
    rotate: -1.2,
    scaleStart: 1,
  },
  {
    id: 13,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/36e1d58eb7112a7011b5dede80c3cc53.jpeg",
    alt: "AI Craft Workshop — student sketching AI characters",
    delay: 1.05,
    floatDuration: 6.4,
    blinkDelay: 1.7,
    rotate: 2.1,
    scaleStart: 1,
  },
  {
    id: 14,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/a98f65b77ebcee6ef682a4f31c082d9a.jpeg",
    alt: "STEMForge school assembly robotics demo session",
    delay: 0.45,
    floatDuration: 5.6,
    blinkDelay: 2.0,
    rotate: -0.9,
    scaleStart: 1,
  },
  {
    id: 15,
    src: "https://static.readdy.ai/image/c2fbe695e557781efe45beda2c2e7ab3/3cfd2925c1b2946d441d2a45a00becc5.jpeg",
    alt: "AI & Python classroom session — instructor at board",
    delay: 0.75,
    floatDuration: 6.7,
    blinkDelay: 1.4,
    rotate: 1.6,
    scaleStart: 1,
  },
];

interface PhotoCardProps {
  photo: JourneyPhoto;
  isVisible: boolean;
}

function PhotoCard({ photo, isVisible }: PhotoCardProps) {
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [dragStart, setDragStart] = useState({ x: 0, y: 0, posX: 0, posY: 0 });
  const [isHovered, setIsHovered] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  const handleMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    setDragStart({
      x: e.clientX,
      y: e.clientY,
      posX: position.x,
      posY: position.y,
    });
    e.preventDefault();
  };

  const handleMouseMove = (e: MouseEvent) => {
    if (!isDragging) return;
    const dx = e.clientX - dragStart.x;
    const dy = e.clientY - dragStart.y;
    setPosition({ x: dragStart.posX + dx, y: dragStart.posY + dy });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleTouchStart = (e: React.TouchEvent) => {
    const touch = e.touches[0];
    setIsDragging(true);
    setDragStart({
      x: touch.clientX,
      y: touch.clientY,
      posX: position.x,
      posY: position.y,
    });
  };

  const handleTouchMove = (e: TouchEvent) => {
    if (!isDragging) return;
    const touch = e.touches[0];
    const dx = touch.clientX - dragStart.x;
    const dy = touch.clientY - dragStart.y;
    setPosition({ x: dragStart.posX + dx, y: dragStart.posY + dy });
    e.preventDefault();
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
      window.addEventListener("touchmove", handleTouchMove, { passive: false });
      window.addEventListener("touchend", handleTouchEnd);
    }
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDragging, dragStart]);

  const floatKeyframeStyle = `
    @keyframes float-${photo.id} {
      0%, 100% { transform: translateY(0px) rotate(${photo.rotate}deg); }
      25% { transform: translateY(-8px) rotate(${photo.rotate + 0.5}deg); }
      75% { transform: translateY(6px) rotate(${photo.rotate - 0.5}deg); }
    }
    @keyframes blink-border-${photo.id} {
      0%, 100% { box-shadow: 0 0 0 0px rgba(16,185,129,0); }
      50% { box-shadow: 0 0 0 3px rgba(16,185,129,0.6); }
    }
  `;

  return (
    <>
      <style>{floatKeyframeStyle}</style>
      <div
        ref={cardRef}
        className={`relative group select-none transition-opacity duration-700 ${
          isVisible ? "opacity-100" : "opacity-0"
        }`}
        style={{
          transform: `translate(${position.x}px, ${position.y}px)`,
          animation: isDragging || isHovered
            ? "none"
            : `float-${photo.id} ${photo.floatDuration}s ease-in-out ${photo.delay}s infinite, blink-border-${photo.id} 3s ease-in-out ${photo.blinkDelay}s infinite`,
          cursor: isDragging ? "grabbing" : "grab",
          zIndex: isDragging ? 50 : isHovered ? 10 : 1,
          transitionDelay: `${photo.delay}s`,
        }}
        onMouseDown={handleMouseDown}
        onTouchStart={handleTouchStart}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div
          className="rounded-xl overflow-hidden bg-white p-1.5 pb-6 transition-transform duration-300"
          style={{
            transform: isHovered && !isDragging ? "scale(1.06)" : "scale(1)",
            boxShadow: isDragging
              ? "0 20px 40px rgba(0,0,0,0.25)"
              : "0 4px 20px rgba(0,0,0,0.12)",
          }}
        >
          <div className="w-full h-44 md:h-48 overflow-hidden rounded-lg">
            <img
              src={photo.src}
              alt={photo.alt}
              className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
              draggable={false}
            />
          </div>
          {/* Polaroid bottom strip */}
          <div className="px-1 pt-2 pb-0 text-center">
            <p className="text-xs text-gray-500 font-medium truncate" style={{ fontFamily: "'Caveat', cursive" }}>
              {photo.alt.length > 30 ? photo.alt.slice(0, 30) + "…" : photo.alt}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default function OurJourney() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="py-24 bg-white overflow-hidden">
      {/* Load Caveat handwriting font */}
      <link
        href="https://fonts.googleapis.com/css2?family=Caveat:wght@400;600&display=swap"
        rel="stylesheet"
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-100 text-emerald-700 text-sm font-semibold uppercase tracking-wider rounded-full mb-4">
            Memories
          </div>
          <h2
            className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Our Journey{" "}
            <span className="text-emerald-600">in Frames</span>
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto">
            Moments captured across workshops, labs, and institutions — every photo tells a story of impact.
          </p>
        </div>

        {/* Photo Grid — 5 columns like demo */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-5 md:gap-6">
          {journeyPhotos.map((photo) => (
            <PhotoCard key={photo.id} photo={photo} isVisible={isVisible} />
          ))}
        </div>

        {/* Bottom decoration */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 text-gray-400 text-sm">
            <span className="block w-12 h-px bg-gray-200"></span>
            <i className="ri-heart-line text-emerald-500 text-lg"></i>
            <span>Every session. Every student. Every milestone.</span>
            <i className="ri-heart-line text-emerald-500 text-lg"></i>
            <span className="block w-12 h-px bg-gray-200"></span>
          </div>
        </div>
      </div>
    </section>
  );
}
